module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"upload":{"file":{"title":"Uploading your file... please wait."}}},"es":{"upload":{"file":{"title":"Cargando su archivo... por favor espere."}}},"fr":{"upload":{"file":{"title":"Téléchargement de votre fichier... veuillez patienter."}}},"pt":{"upload":{"file":{"title":"Carregando o seu ficheiro... aguarde, por favor."}}},"de":{"upload":{"file":{"title":"Hochladen Ihrer Datei... bitte warten."}}},"nl":{"upload":{"file":{"title":"Upload uw bestand... wacht even."}}}}')
  delete Component.options._Ctor
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@intlify/vue-i18n-loader/lib!./node_modules/vue-loader/lib/selector.js?type=customBlocks&index=0!./src/components/v3/buttons/UploadButton.vue
// module id = KPhT
// module chunks = 10